module.exports = __webpack_public_path__ + "static/media/section03_1.4171939e.jpg";